<template>
  <div class="otherBind">
    <gwlz :show.sync="showgwPopup" @colsegwPopup="showgwPopup = false"></gwlz>
    <div class="pic">
      <img src="@static/images/personal/bindPolicyOther.png" alt="" />
    </div>
    <div class="desc">请联系专属管家协助绑定保单</div>
    <div class="btnlist">
      <!-- <div class="btn active" @click="goYygw()">我的顾问</div> -->
      <div class="btn" @click="goto('https://wtsbx.qiyukf.com/client?k=59ed88a4552beb1d89cb502bb4885dd6&wp=1&robotShuntSwitch=0&gid=484878140&language=zh-cn&templateId=6674361',1)">在线客服</div>
    </div>
  </div>
</template>
<script>
//当前实例组件
var vm = null;
import gwlz from "@/components/commons/gwlz";
export default {
  data() {
    return {
      gwInfo: null, //顾问信息
      showgwPopup: false,
    };
  },
  components: {
    gwlz: gwlz,
  },
  created() {
    vm = this;
    vm.hasGwInfo();
  },
  methods: {
    goto(path,type){
      if(type){
        window.location.href = path;
        return;
      }
      this.$router.push({
        path: path,
      });
    },
    goYygw(){
      if (vm.gwInfo) {
        this.$units.goYygw(this, 1);
      } else {
        vm.showgwPopup = true;
      }
    },
    //是否绑定过顾问
    hasGwInfo() {
      vm.$http({
        type: "GET",
        url: "/app/agent/api/currAgent",
        data: {},
      })
        .then((data) => {
          if (data.data) {
            vm.gwInfo = data.data;
          }
        })
        .catch((err) => {});
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.otherBind {
  width: 100%;
  height: 100vh;
  background: #fff;
  .pic {
    width: 100%;
    text-align: center;
    img {
      width: 440px;
      height: 315px;
      padding-top: 130px;
    }
  }
  .desc {
    font-size: 30px;
    font-weight: 400;
    color: #3c464f;
    line-height: 45px;
    margin-top: 20px;
    padding: 0 70px;
    text-align: center;
    margin-top: 20px;
  }

  .title {
    margin-top: 90px;
    font-size: 32px;
    font-weight: 900;
    color: #000000;
    line-height: 45px;
    text-align: center;
  }
  .btnlist {
    display: flex;
    justify-content: space-around;
    margin-top: 120px;
    padding: 0 30px;
    .btn {
      width: 300px;
      height: 90px;
      background: rgba(55, 122, 255, 0.08);
      border-radius: 46px;
      font-size: 34px;
      font-weight: 500;
      color: #377AFF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      &.active{
        color: #fff;
        background: #377AFF;
      }
    }
  }
}
</style>